import type { InputProps } from "@/components/ui/Input/Input";
import styled from "styled-components";

const StyledInput = styled.div<InputProps>`
  display: block;
  position: relative;
  margin-bottom: ${({ $marginbottom }) => $marginbottom};
  width: inherit;
  width: 100%;

  label {
    font-size: 14px;
    color: var(--inputLabelColor, #000);
    font-weight: 500;
    text-align: left;
    display: flex;
    align-items: center;
    line-height: 1;
    gap: 0.125rem;
    margin-bottom: 0.25rem;
    position: relative;

    ${({ required }) =>
      required
        ? `
      &::after {
        content: '*';
        color: red;
      }
      `
        : ""}
  }

  .inputWrapper {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    position: relative;
    width: 100%;
    border: ${({ $border }) => `1px solid ${$border ?? "gray"} `};
    border-radius: ${({ $borderRadius }) => $borderRadius};
    padding: 0 1rem;
    height: ${({ height }) => height};
    // background-color: ${({ $bgColor }) => $bgColor ?? "var(--inputBgColor, #fafafa)"};

    &:focus-within {
      border: 1px solid var(--primary, #171926);
    }

    &:hover {
      // border: 1px solid var(--neutral600, gray);
    }
  }

  .inputWrapper[data-disabled="true"] {
    background-color: var(--disabledInput, #f5f5f5);
    cursor: not-allowed;
    border: 1px solid var(--disabledInput, #f5f5f5);
  }

  .prefixIcon,
  .suffixIcon {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 1.25rem !important;
      object-fit: cover;
    }
    svg {
      width: 1.25rem !important;
      height: auto !important;
      font-size: 1.25rem !important;
    }
  }

  .input-container {
    position: relative;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    color: #5e6c84;
    border: none;
    width: ${(props) => props.$width};
    transition: 0.3s;
    background: transparent;
    align-items: center;

    input {
      width: 100%;
      box-sizing: border-box;
      border: none;
      color: var(--neutral, #000);
      transition: 0.3s;
      background-color: transparent;
      font-size: 1rem;
      display: inline-flex;
      align-items: center;
      font-size: ${(props) => props.$fontSize};

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: ${({ $placeholderColor }) => $placeholderColor ?? "var(--neutral400, #A6A6A6)"};
      }
    }

    input:disabled {
      background-color: var(transparent, --disabledInput, #f5f5f5);
      color: var(--neutral400, #b3b3b3);
      cursor: not-allowed;
    }
  }

  .error {
    font-size: 12px;
    color: var(--error, #eb5757);
    position: absolute;
    left: 0;
    text-align: left;
    padding: 0.25rem 0px 0px 0px;
    margin: 0px;
    line-height: 1;
  }
  .eye-icon {
    cursor: pointer;

    path {
      stroke: var(--neutral, #000);
    }
  }
  position: relative;
`;

export default StyledInput;
